import React from 'react';
import Labels from './../../../../common/Labels'
import { connect } from 'react-redux';
import MomentDateAndTime from '../../../../../helpers/momentDateAndTime';
class ModifiedOnClass extends React.Component {
    render() {
        return <Labels
            name="Modified On"
            text={MomentDateAndTime(this.props.playbookTimeStamp)} />
    }
}
function mapStateToProps(state) {
    return {
        playbookTimeStamp: state.lifeCycle.playbookTimeStamp
    }
}
export default connect(mapStateToProps)(ModifiedOnClass);